
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from './Power/Login';
import Navbar from './Power/Navbar';
import Home from './Power/Home';

const HomeWrapper = () => {
  const navigate = useNavigate();
  
  const handleCardClick = (section) => {
    sessionStorage.setItem('currentSection', section);
    const routes = {
      'employees': '/employees',
      'projects': '/projects',
      'reports': '/reports',
      'vendors': '/vendors',
      'clients': '/clients',
      'taxInvoices': '/taxinvoices',
      'performaInvoices': '/performainvoices',
      'reportSubmission': '/reportsubmission'
    };
    if (routes[section]) {
      navigate(routes[section]);
    }
  };
  
  return <Home onCardClick={handleCardClick} />;
};

const App = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    const storedUser = localStorage.getItem('currentUser');
    const authToken = localStorage.getItem('authToken');
    const userEmail = localStorage.getItem('currentUserEmail');
    
    if (storedUser && (authToken || userEmail)) {
      try {
        const userData = JSON.parse(storedUser);
        setCurrentUser(userData);
        setIsLoggedIn(true);
      } catch (error) {
        console.error('Error parsing stored user data:', error);
        localStorage.removeItem('currentUser');
        localStorage.removeItem('authToken');
        localStorage.removeItem('currentUserEmail');
        localStorage.removeItem('currentUserName');
        localStorage.removeItem('currentUserId');
      }
    }
    setIsLoading(false);
  }, []);
  
  const handleLoginSuccess = (userData) => {
    console.log('Login successful, user data:', userData);
    setCurrentUser(userData);
    setIsLoggedIn(true);
  };
  
  const handleLogout = () => {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentUserEmail');
    localStorage.removeItem('currentUserName');
    localStorage.removeItem('currentUserId');
    localStorage.removeItem('currentUserProfileImage');
    localStorage.removeItem('authToken');
    sessionStorage.removeItem('currentSection');
    sessionStorage.removeItem('showHome');
    
    setCurrentUser(null);
    setIsLoggedIn(false);
    
    console.log('User logged out successfully');
  };
  
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }
  
  return (
    <Router>
      <div className="App">
        {isLoggedIn ? (
          <Routes>
            <Route path="/" element={<HomeWrapper />} />
            <Route path="/employees" element={<Navbar currentUser={currentUser} onLogout={handleLogout} initialSection="employees" />} />
            <Route path="/projects" element={<Navbar currentUser={currentUser} onLogout={handleLogout} initialSection="projects" />} />
            <Route path="/reports" element={<Navbar currentUser={currentUser} onLogout={handleLogout} initialSection="reports" />} />
            <Route path="/vendors" element={<Navbar currentUser={currentUser} onLogout={handleLogout} initialSection="vendors" />} />
            <Route path="/clients" element={<Navbar currentUser={currentUser} onLogout={handleLogout} initialSection="clients" />} />
            <Route path="/taxinvoices" element={<Navbar currentUser={currentUser} onLogout={handleLogout} initialSection="taxInvoices" />} />
            <Route path="/performainvoices" element={<Navbar currentUser={currentUser} onLogout={handleLogout} initialSection="performaInvoices" />} />
            <Route path="/reportsubmission" element={<Navbar currentUser={currentUser} onLogout={handleLogout} initialSection="reportSubmission" />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<Login onLoginSuccess={handleLoginSuccess} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        )}
      </div>
    </Router>
  );
};

export default App;